<template>
  <div>
    <UIProgressCircular v-show="!dataLoaded" />

    <div v-show="dataLoaded" class="mt-4">
      <div class="d-flex align-center justify-space-between">
        <v-btn
          text
          small
          height="32"
          class="action-btn elevation-0 rounded-lg"
          @click="$router.push('/spm/events/eventsPage')"
        >
          <v-icon class="uikit-icon chevron-left size-20" />
          <span class="ml-1 btn-text">Вернуться</span>
        </v-btn>

        <h3 v-if="!isXs" style="word-break: break-word" class="text-end">
          {{ event.name }}
        </h3>

        <TabsUI
          v-if="!isXs"
          :list="tabs"
          :selected-tab="tabs.findIndex(obj => obj.id === selectedTab.id)"
          @click="(tab) => selectedTab = tab"
        />
      </div>

      <h3 v-if="isXs" style="word-break: break-word" class="text-center">
        {{ event.name }}
      </h3>

      <TabsUI
        v-if="isXs"
        :list="tabs"
        class="mt-2"
        :selected-tab="tabs.findIndex(obj => obj.id === selectedTab.id)"
        @click="(tab) => selectedTab = tab"
      />

      <v-row class="my-0 mt-3">
        <v-col v-if="selectedTab.id === 2" cols="12" class="pt-0">
          <EventCard
            ref="eventCard"
            :form-template-list="formTemplateList.list"
            :current-event="event"
          />
        </v-col>

        <v-col v-if="selectedTab.id === 1" cols="12" class="pt-0">
          <v-card ref="mainCard" class="base-card pa-4">
            <v-card-title class="d-flex justify-space-between pa-0">
              <span>Формы</span>

              <ButtonOutlineSmall
                v-if="isAdmin"
                class="mb-1"
                title="Добавить"
                icon="plus"
                :loading="getAllFormTemplateLoading"
                @click="checkBeforeAddNewForm"
              />
            </v-card-title>

            <v-data-table
              v-if="!isXs"
              ref="table"
              v-scroll.self="tableScroll"
              class="elevation-0"
              :class="isXs ? 'mobile-table' : 'base-table'"
              :loading="tableLoading"
              :headers="tableHeaders"
              :items="formTemplateList.list"
              :items-per-page="-1"
              loading-text="Загрузка"
              no-data-text="Нет данных"
              no-results-text="Не найдено"
              hide-default-footer
              fixed-header
            >
              <template #[`item.actions`]="{ item }">
                <ActionsBtnForForm
                  @goToFilledFormValue="goToFilledFormValue(item)"
                  @edit="edit(item)"
                  @goToFilledForm="goToFilledForm(item)"
                  @goToMailForEventForm="goToMailForEventForm(item)"
                  @downloadXlsxTemplate="downloadXlsxTemplate(item)"
                  @openFormTemplateExcelDialog="openFormTemplateExcelDialog(item)"
                  @openReportTemplatesListForDownloadDialog="openReportTemplatesListForDownloadDialog(item)"
                  @goToReportTemplatesForEventForm="goToReportTemplatesForEventForm(item)"
                  @downloadEventBadge="downloadEventBadge(item)"
                  @openBadgesPage="openBadgesPage(item)"
                  @remove="remove(item)"
                />
              </template>

              <template slot="no-data">
                <div>Таблица пуста</div>
              </template>
            </v-data-table>

            <v-list v-if="isXs" ref="list" class="px-4 pt-0 transparent overflow-auto">
              <v-row class="my-0 mt-4">
                <v-col
                  v-for="(item) of formTemplateList.list" :key="item.id"
                  cols="12"
                  class="pt-0 d-flex" :class="$vuetify.breakpoint.xs ? 'px-0' : ''"
                >
                  <v-card
                    class="base-card hover-card cursor-pointer pb-4 w-full d-flex flex-column justify-space-between"
                    :ripple="false"
                  >
                    <div>
                      <div class="d-flex justify-space-between align-center ma-3 mb-0">
                        <v-chip outlined small>
                          {{ item.status.name }}
                        </v-chip>

                        <ActionsBtnForForm
                          @goToFilledFormValue="goToFilledFormValue(item)"
                          @edit="edit(item)"
                          @goToFilledForm="goToFilledForm(item)"
                          @goToMailForEventForm="goToMailForEventForm(item)"
                          @downloadXlsxTemplate="downloadXlsxTemplate(item)"
                          @openFormTemplateExcelDialog="openFormTemplateExcelDialog(item)"
                          @openReportTemplatesListForDownloadDialog="openReportTemplatesListForDownloadDialog(item)"
                          @goToReportTemplatesForEventForm="goToReportTemplatesForEventForm(item)"
                          @downloadEventBadge="downloadEventBadge(item)"
                          @openBadgesPage="openBadgesPage(item)"
                          @remove="remove(item)"
                        />
                      </div>

                      <v-card-title class="pb-0" style="word-break: break-word">
                        {{ item.name }}
                      </v-card-title>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <FormTemplateDialog
      :dialog="dialog"
      :save-btn-loading="saveBtnLoading"
      :selected-item="selectedItem"
      :is-show-mode="isShowMode"
      :all-form-template-list="allFormTemplateList"
      @saveFormTemplate="saveFormTemplate"
      @copyFormTemplate="copyFormTemplate"
      @closeModal="closeDialog"
    />

    <FormTemplateExcelDialog
      :dialog="excelDialog"
      :save-btn-loading="saveBtnLoading"
      @saveFormTemplateExcel="saveFormTemplateExcel"
      @closeModal="closeFormTemplateExcelDialog"
    />

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="removeLoading"
      :message="`Вы уверены, что вы хотите это удалить?`"
      @confirm="removeFormTemplate"
      @closeConfirmModal="closeConfirmDialog"
    />

    <ChoosingReportTemplatesListForDownloadDialog
      :dialog="isOpenedReportTemplatesListForDownloadDialog"
      :selected-item="selectedItem"
      @closeModal="closeChoosingReportTemplatesListForDownloadDialog"
    />

    <WarningDialog
      :dialog="isOpenedWarningDialog"
      @close="isOpenedWarningDialog = false"
    >
      <template #text>
        <div class="d-flex row justify-center">
          <span> {{ textForWarningDialog }}</span>
          <a
            href="/instructions_for_setting_up_statuses.pdf"
            download="инструкция_по_настройке_статусов.pdf"
            class="file-link"
            @click="openInstructionsInNewTab"
          >
            <span>Инструкция по настройке статусов</span>
          </a>
        </div>
      </template>

      <template #action>
        <v-btn
          link
          :href="graphUrl"
          target="_blank"
          outlined
          color="primary"
          class="px-4 d-flex align-center"
          @click="isOpenedWarningDialog = false"
        >
          <v-icon size="18">
            mdi-arrow-top-right
          </v-icon>
          <span class="btn-text">Сервис графов</span>
        </v-btn>
      </template>
    </WarningDialog>
  </div>
</template>

<script>
import { cloneDeep, debounce } from 'lodash'
import { mapGetters } from 'vuex'
import { FormTemplateList, FormTemplate, Event } from '@/models'
import { formTemplateApi, excelApi, badgeApi, eventApi } from '@/api'
import FormTemplateDialog from '@/components/Spm/Events/FormTemplatePage/dialogs/FormTemplateDialog'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog'
import UIProgressCircular from '@/ui/progress/UIProgressCircular'
import download from '@/plugins/download'
import FormTemplateExcelDialog from '@/components/Spm/Events/FormTemplatePage/dialogs/FormTemplateExcelDialog'
import EventCard from '@/components/Spm/Events/FormTemplatePage/EventCard'
import ListItemButton from '@/featureSlicedDesign/entites/ListItemButton'
import ButtonOutlineSmall from '@/featureSlicedDesign/shared/ui/ButtonOutlineSmall'
import TabsUI from '@/featureSlicedDesign/shared/ui/TabsUI'
import ChoosingReportTemplatesListForDownloadDialog
  from '@/components/Spm/Events/FormTemplatePage/dialogs/ChoosingReportTemplatesListForDownloadDialog'
import WarningDialog from '@/components/dialogs/WarningDialog'
import ActionsBtnForForm from '@/components/Spm/Events/FormTemplatePage/ActionsBtnForForm'

export default {
  name: 'FormTemplatePage',

  metaInfo: { title: 'Формы' },

  components: {
    ButtonOutlineSmall,
    ListItemButton,
    EventCard,
    FormTemplateExcelDialog,
    UIProgressCircular,
    FormTemplateDialog,
    ConfirmDialog,
    TabsUI,
    ChoosingReportTemplatesListForDownloadDialog,
    WarningDialog,
    ActionsBtnForForm,
  },

  async created() {
    await this.getFormTemplateList()
    await this.getEvent()
    this.dataLoaded = true
  },

  mounted() {
    this.setTableHeight()
    window.addEventListener('resize', this.setTableHeight)
  },

  destroyed() {
    window.removeEventListener('resize', this.setTableHeight)
  },

  data: () => ({
    formTemplateList: new FormTemplateList(),
    event: new Event(),
    allFormTemplateList: [],

    selectedTab: { id: 1, name: 'Формы' },
    tabs: [
      { id: 1, name: 'Формы' },
      { id: 2, name: 'Мероприятие' },
    ],

    tableHeaders: [
      // { text: 'id', value: 'id', sortable: false, align: 'start' },
      {
        text: 'Название',
        value: 'name',
        sortable: false,
        align: 'start',
      },
      // { text: 'Мероприятие', value: 'event.name', sortable: false, align: 'start' },
      {
        text: 'Статус',
        value: 'status.name',
        sortable: false,
        align: 'start',
      },
      {
        text: 'Действия',
        value: 'actions',
        sortable: false,
        align: 'end',
        width: '345px',
      },
    ],

    // pageNumber: 0,
    // lastPage: false,
    // total: 0,
    // filters: new PersonFilters(),

    selectedItem: null,
    selectedFormTemplateId: null,

    confirmDialog: false,
    dialog: false,
    excelDialog: false,


    isShowMode: false,

    toPublishEventLoading: false,
    tableLoading: false,
    saveBtnLoading: false,
    removeLoading: false,
    dataLoaded: false,
    isOpenedReportTemplatesListForDownloadDialog: false,
    isOpenedWarningDialog: false,
    textForWarningDialog: null,
    graphUrl: process.env.VUE_APP_GRAPH_URL,
    getAllFormTemplateLoading: false,

    isHasFastRegistration: false,
    isHasFinalStatus: false,
    isHasInitialStatus: false,
  }),

  computed: {
    ...mapGetters('breakpoint', ['isXs']),
    ...mapGetters('settings', ['isShowFullNews']),
    ...mapGetters('user', ['isAdmin']),
  },

  methods: {
    openFormTemplateExcelDialog(item) {
      this.selectedItem = item
      this.excelDialog = true
    },

    openReportTemplatesListForDownloadDialog(item) {
      this.selectedItem = item
      this.isOpenedReportTemplatesListForDownloadDialog = true
    },

    closeChoosingReportTemplatesListForDownloadDialog() {
      this.isOpenedReportTemplatesListForDownloadDialog = false
      this.selectedItem = null
    },

    openBadgesPage(item) {
      this.$router.push(`/spm/events/${item.event.id}/formTemplate/${item.id}/badges`)
    },

    async getEvent() {
      try {
        const data = await eventApi.get(this.$route.params.id)
        this.event = new Event(data.event)
        this.isHasFastRegistration = data.isHasFastRegistration
        this.isHasFinalStatus = data.isHasFinalStatus
        this.isHasInitialStatus = data.isHasInitialStatus
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка получения мероприятия')
      }
    },

    async getFormTemplateList() {
      try {
        // if (!this.lastPage) {
        this.tableLoading = true

        // const { content, last, totalElements } = await eventApi.getCatalog()
        const content = await formTemplateApi.findAllByEventId(this.$route.params.id)
        // if (this.pageNumber === 0) this.formTemplateList = new FormTemplateList()
        this.formTemplateList = new FormTemplateList()
        // this.lastPage = last
        // this.total = totalElements
        // this.pageNumber++

        content.length && content.forEach((obj) => this.formTemplateList.add(obj))
        // }
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка получения форм')
      } finally {
        this.tableLoading = false
      }
    },

    openInstructionsInNewTab() {
      window.open('/instructions_for_setting_up_statuses.pdf', '_blank')
      this.isOpenedWarningDialog = false
    },

    checkBeforeAddNewForm() {
      if (this.isHasInitialStatus) {
        this.addNew()
      } else {
        this.isOpenedWarningDialog = true
        this.textForWarningDialog = 'Для создания регистрационной формы необходимо сначала задать статусы мероприятия.\n'
          + 'Вы можете сделать это в сервисе графов или ознакомиться с инструкцией.'
      }
    },

    async getAllFormTemplate() {
      try {
        this.getAllFormTemplateLoading = true
        this.allFormTemplateList = await formTemplateApi.findAll()
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Ошибка получения списка форм ')
      } finally {
        this.getAllFormTemplateLoading = false
      }
    },

    async addNew() {
      this.selectedItem = new FormTemplate({ event: { id: this.$route.params.id } })
      await this.getAllFormTemplate()
      this.dialog = true
    },

    goToFilledForm(item) {
      if (this.isHasFastRegistration) {
        this.$router.push(`/spm/form/${item.id}/manualRegistration`)
      } else {
        this.isOpenedWarningDialog = true
        this.textForWarningDialog = 'Для использования «Регистрации на месте» необходимо задать переход из начального статуса в конечный'
      }
    },

    goToMailForEventForm(item) {
      this.$router.push(`/spm/form/${item.id}/mail`)
    },

    goToFilledFormValue(item) {
      this.$router.push(`/spm/events/filledFormValue/${item.id}`)
    },

    goToReportTemplatesForEventForm(item) {
      this.$router.push(`/spm/form/${item.id}/reportTemplates`)
    },

    edit(item) {
      this.$router.push(`/spm/formConstructor/${item.id}`)
    },

    remove(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    async downloadXlsxTemplate(item) {
      try {
        this.tableLoading = true
        const data = await excelApi.downloadXlsxTemplate(item.id)

        download(data, `Форма (${item.name}).xlsx`)
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка загрузки')
      } finally {
        this.tableLoading = false
      }
    },

    async saveFormTemplate(body) {
      try {
        this.saveBtnLoading = true
        const data = body.id ? await formTemplateApi.update(body) : await formTemplateApi.create(body)
        body.id ? this.formTemplateList.update(data) : this.formTemplateList.add(data)

        this.$toastr('success', '', 'Успешно сохранено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    async copyFormTemplate(formTemplatePrototype) {
      try {
        this.saveBtnLoading = true
        const data = await formTemplateApi.copyFormTemplateToNewEvent(
          this.$route.params.id,
          formTemplatePrototype.id,
        )

        this.allFormTemplateList.push(data)
        this.formTemplateList.add(data)

        this.$toastr('success', '', 'Успешно сохранено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    async saveFormTemplateExcel(file) {
      try {
        this.tableLoading = true
        await excelApi.uploadFilledFormsFromXlsx(file, this.selectedItem.id)

        this.goToFilledFormValue(this.selectedItem)

        this.$toastr('success', '', 'Успешно сохранено')
        this.closeFormTemplateExcelDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.tableLoading = false
      }
    },

    async downloadEventBadge(item) {
      try {
        this.tableLoading = true
        const file = await badgeApi.getBadgeArchiveByFormTemplateId(item.id)
        download(file, `Шаблон бейджа формы ${item.id}.zip`)
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка загрузки шаблона')
      } finally {
        this.tableLoading = false
      }
    },

    async saveUploadTemplate(badge) {
      try {
        badge.id ? await badgeApi.update(badge) : await badgeApi.create(badge)
        this.$toastr('success', '', 'Успешно сохранено')
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка загрузки шаблона')
      }
    },

    async removeFormTemplate() {
      try {
        this.removeLoading = true
        await formTemplateApi.remove(this.selectedItem.id)
        this.formTemplateList.remove(this.selectedItem.id)
        this.$toastr('success', '', 'Успешно удалено')
        this.closeConfirmDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка удаления')
      } finally {
        this.removeLoading = false
      }
    },

    setTableHeight() {
      this.$nextTick(() => {
        if (this.$refs?.table) {
          const footerHeight = 67
          const topHeight = this.$refs.table.$el.getBoundingClientRect().top

          this.$refs.table.$el.style.height = `${window.innerHeight - topHeight - footerHeight}px`
        }

        if (this.$refs?.list) {
          const footerHeight = 67
          const topHeight = this.$refs.list.$el.getBoundingClientRect().top

          this.$refs.list.$el.style.height = `${window.innerHeight - topHeight - footerHeight}px`
        }

        if (this.$refs?.eventCard) {
          const footerHeight = 51
          const topHeight = this.$refs.eventCard.$el.getBoundingClientRect().top

          this.$refs.eventCard.$el.style.height = `${window.innerHeight - topHeight - footerHeight}px`
        }

        if (this.$refs?.eventCard?.$refs.list) {
          const footerHeight = 67
          const topHeight = this.$refs?.eventCard.$refs.list.$el.getBoundingClientRect().top

          this.$refs.eventCard.$refs.list.$el.style.height = `${window.innerHeight - topHeight - footerHeight}px`
        }
      })
    },

    tableScroll(event) {
      const el = event.target
      if (el.scrollHeight - el.clientHeight - el.scrollTop <= 10 && !this.tableLoading) {
        // this.getFormTemplateList()
      }
    },

    setFilters: debounce(async function debounceSetFilters(filters) {
      this.filters = cloneDeep(filters)
    }, 500),

    closeDialog() {
      this.dialog = false
      this.selectedItem = null
      this.isShowMode = false
    },

    closeFormTemplateExcelDialog() {
      this.excelDialog = false
    },

    closeConfirmDialog() {
      this.confirmDialog = false
      this.selectedItem = null
    },
  },

  watch: {
    dataLoaded() {
      this.setTableHeight()
    },

    filters: {
      deep: true,
      async handler() {
        this.pageNumber = 0
        this.lastPage = false
        this.total = 0
        await this.getFormTemplateList()
      },
    },

    isShowFullNews() {
      this.setTableHeight()
    },
  },
}
</script>
